import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useState, useEffect } from 'react';
import { useCheckoutContext as useCheckoutContext$1 } from '@zooplus/checkout-state';
import useCheckoutContext from '../tests/StorybookTests/hooks/useCheckoutContext.js';
import { selectConfig } from '../utils/configUtils.js';
import { getInitialPaymentMethods, getInitialSelectedPayment } from '../utils/modernizePaymentUtils.js';

const PaymentContext = createContext({
    updateSelectedPayment: () => { },
    deleteSavedCard: () => { },
    setSelectedPayment: () => { },
});
const usePaymentContext = () => useContext(PaymentContext);
const PaymentContextProvider = ({ children, isDataMocked = false, }) => {
    const useLoadCheckoutContext = isDataMocked ? useCheckoutContext : useCheckoutContext$1;
    const { paymentState, appConfig } = useLoadCheckoutContext('payment-frontend');
    const config = selectConfig(appConfig?.environment)(appConfig?.realm);
    const { deleteSavedCard: deleteSavedCardMutation, updatePreferredPayment } = paymentState || {};
    const [selectedPayment, setSelectedPayment] = useState(); //for internal use
    const [checkoutState, setCheckoutState] = useState(getInitialPaymentMethods(paymentState, config.adyen.clientKey));
    useEffect(() => {
        const transformedPaymentState = getInitialPaymentMethods(paymentState, config.adyen.clientKey);
        if (!paymentState?.isPaymentLoading) {
            const selectedPM = transformedPaymentState?.paymentMethods &&
                getInitialSelectedPayment(transformedPaymentState?.paymentMethods, transformedPaymentState?.customerType, transformedPaymentState?.preferredPayment?.paymentMethodShortName || '');
            setSelectedPayment(selectedPM);
        }
        setCheckoutState(transformedPaymentState);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(paymentState)]);
    const updateSelectedPayment = (data) => {
        updatePreferredPayment?.(data);
        console.log('clicked on updateSelectedPayment: ', data);
    };
    const deleteSavedCard = (body) => deleteSavedCardMutation && deleteSavedCardMutation(body);
    return (jsx(PaymentContext.Provider, { value: {
            appConfig,
            selectedPayment,
            checkoutState,
            updateSelectedPayment,
            deleteSavedCard,
            setSelectedPayment,
        }, children: children }));
};

export { PaymentContext, PaymentContextProvider, PaymentContextProvider as default, usePaymentContext };
//# sourceMappingURL=PaymentContextProvider.js.map
